import { authGuard } from '@/app/auth/authGuard';

export default { authGuard };

export * from './authWrapper';
